import { Clear } from "@mui/icons-material";
import { Box, Drawer } from "@mui/material";
import { red } from "@mui/material/colors";
import PropTypes from "prop-types";
import React, { useState } from "react";

export default function StelDrawer(props) {
  const { anchor, open, title, onClose, children, width } = props;

  const [boxShadow, setBoxShadow] = useState(null);

  const onScroll = (e) => {
    if (e.target.scrollTop > 10) {
      setBoxShadow({ boxShadow: "0px 1px 2px rgba(0,0,0,0.39)" });
    } else {
      setBoxShadow(null);
    }
  };

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      sx={{
        maxWidth: 700,
        width: "100%",
        padding: "15px",
      }}
      onScrollCapture={onScroll}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: `calc(${width}px - 48px)`,
          background: "#fff",
          padding: "15px 24px 0px",
          zIndex: 2,
          ...(boxShadow && boxShadow),
        }}
      >
        {title && (
          <Box
            sx={{
              margin: 0,
            }}
          >
            {title}
          </Box>
        )}
        <Clear
          sx={{
            color: red[500],
            fontSize: "20px",
            padding: "2px",
            "&:hover": {
              background: "#ECECF3",
            },
            cursor: "pointer",
          }}
          onClick={onClose}
        />
      </Box>
      <Box sx={{ marginTop: 0 }}>{children}</Box>
    </Drawer>
  );
}

StelDrawer.propTypes = {
  anchor: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
};

StelDrawer.defaultProps = {
  width: 500,
};
